import type { ReactNode } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';
import { Button } from '../../../../components/Button';

interface DuplicateConfirmDialogProps {
  children: ReactNode;
  title: string;
  onConfirm: () => void;
  isLoading?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export default function DuplicateConfirmDialog({
  children,
  title,
  onConfirm,
  isLoading = false,
  open,
  onOpenChange,
}: DuplicateConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>求人の複製</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-lg">
          <AlertDialogDescription>「{title}」を複製しますか？</AlertDialogDescription>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button color="secondary" size="md">
              キャンセル
            </Button>
          </AlertDialogCancel>
          <Button color="primary" size="md" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? '複製中...' : '複製する'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
